import { Icon } from 'shared/iconpack'

import { useMemo } from 'react'

import { useNavigate, useParams } from 'react-router-dom'

import PrimaryButton from 'shared/ui/PrimaryButton'

import { useAppSelector } from 'shared/config/redux/hooks/useRedux'
import { palette } from 'shared/config/styles/palette'

const CreateOrderButton = () => {
  const navigate = useNavigate()
  const { restaurant } = useParams()
  const { data: ordersDrafts } = useAppSelector((state) => state.createOrder)
  const companyForms = useMemo(() => {
    return restaurant ? (ordersDrafts?.[restaurant] ?? null) : null
  }, [restaurant, ordersDrafts])
  return (
    <PrimaryButton
      text="Создать заказ"
      prefixIcon={
        <Icon
          name="plus"
          width={18}
          height={19}
          color={palette.white}
        />
      }
      onClick={() =>
        navigate(
          `/dashboard/orders/${restaurant}/create/${companyForms ? (Object.keys(companyForms)[0] ?? 1) : 1}`,
        )
      }
    />
  )
}

export default CreateOrderButton
